import { render, staticRenderFns } from "./ResourceUserDashboard.vue?vue&type=template&id=ecd811d4&"
import script from "./ResourceUserDashboard.vue?vue&type=script&lang=js&"
export * from "./ResourceUserDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecd811d4')) {
      api.createRecord('ecd811d4', component.options)
    } else {
      api.reload('ecd811d4', component.options)
    }
    module.hot.accept("./ResourceUserDashboard.vue?vue&type=template&id=ecd811d4&", function () {
      api.rerender('ecd811d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/resources/ResourceUserDashboard.vue"
export default component.exports